import React from 'react';
// import ReactDOM from 'react-dom'; // For React 17
import { createRoot } from 'react-dom/client'; // For React 18
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import './styles/styles.scss';
import App from './App/App';
import reportWebVitals from './reportWebVitals';
import { ThemeContextProvider } from './contexts/themeContext';
import { AuthContextProvider } from './contexts/authContext';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import VendorPortalApp from './vendorPortal/VendorPortalApp';

import './i18n';
const queryClient = new QueryClient();

// The vendor portal is a fully separate app (its own modern UI, auth and axios)
// rendered outside the staff providers/shell. Everything else runs the staff app.
const StaffApp = () => (
	<QueryClientProvider client={queryClient}>
		<AuthContextProvider>
			<ThemeContextProvider>
				<React.StrictMode>
					<App />
				</React.StrictMode>
			</ThemeContextProvider>
		</AuthContextProvider>
	</QueryClientProvider>
);

const children = (
	<Router>
		<Routes>
			<Route path='/vendor-portal/*' element={<VendorPortalApp />} />
			<Route path='*' element={<StaffApp />} />
		</Routes>
	</Router>
);

const container = document.getElementById('root');

// ReactDOM.render(children, container); // For React 17
createRoot(container as Element).render(children); // For React 18

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
